<template>
	<client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">공지사항</h2>
            </div>

            <!-- 1. 게시판 리스트: 베이직 스킨 -->
            <notification-list v-if="!$route.params._notification"></notification-list>
            <notification-view v-else></notification-view>
            <!-- 2. 게시판 작성: 베이직 스킨 -->
            <!-- <board-basic-input></board-basic-input> -->
            <!-- 3. 게시판 뷰: 베이직 스킨 -->
            <!-- <board-basic-view></board-basic-view> -->
        </v-container>
	</client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import NotificationList from "@/components/client/ko/center/notifications/notification-list.vue";
import NotificationView from "@/components/client/ko/center/notifications/notification-view.vue";

export default{
	components: {
        ClientPage,
		NotificationList,
		NotificationView
	},
}
</script>
